(function(module) {
    'use strict';

    module.config(['formlyConfigProvider', (formlyConfigProvider) => {

        let unique = 1;

        formlyConfigProvider.setType({
            name: 'repeatSection',
            template: `
                <div>
                    
                    <!-- REPEATED SECTION -->
                    <div class="repeated-sections">
                        <div class="repeated-section" ng-repeat="element in model[options.key]" ng-init="fields = copyFields(to.fields)">
                            
                            <!-- COLLAPSE BUTTON-->
                            <md-button class="collapse-button" >
                                <i class="fa fa-compress" aria-hidden="true" ng-click="collapse($event)"></i>
                            </md-button>
                            <!-- COLLAPSE BUTTON-->

                            <div id={{$index}}>
                            
                                <formly-form fields="fields" model="element" form="form" class="form-body"></formly-form>
                                
                                <!-- BUTTONS -->
                                <div layout="row" flex="100" layout-align="space-between center" class="buttons-container">
                                    <div layout="row" layout-align="start center">
                                        <md-button class="md-fab md-mini md-warn" ng-click="remove($index)">
                                            <i class="fa fa-trash-o fa-lg"></i>
                                        </md-button>
                                    </div>
                                    <div layout="row" layout-align="end center">
                                        <md-button class="md-fab md-mini md-primary arrow-button" ng-click="up($index)">
                                            <i class="fa fa-arrow-circle-up fa-lg"></i>
                                        </md-button>
                                        <md-button class="md-fab md-mini md-primary arrow-button" ng-click="down($index)">
                                            <i class="fa fa-arrow-circle-down fa-lg"></i>
                                        </md-button>
                                    </div>
                                </div>
                                <!-- //BUTTONS -->
                            </div>
                        </div>
                    </div>
                    <!-- //REPEATED SECTION -->

                    <!-- ADD BUTTON -->
                    <div ng-show="to && to.maxItems && model[options.key].length >= to.maxItems">{{to.maxItemsMessage}}</div>
                    <div layout="row" class="button-wrapper" layout-align="end center">
                        <md-button class="md-raised md-primary main-button" ng-disabled="to && to.maxItems && model[options.key].length >= to.maxItems" ng-click="add()">
                            <i class="s16 fa fa-plus"></i>
                            <span>{{to.addButtonText}}</span>
                        </md-button>
                    </div>
                    <!-- //ADD BUTTON -->
                </div>
            `,
            controller: ['$scope', function($scope) {
                $scope.class = 'expand';

                $scope.collapse = (event) => {

                    // parent class
                    angular.element(event.currentTarget).closest('.repeated-section').toggleClass('collapsed');

                    // buttons classes
                    if (event.currentTarget.className === 'fa fa-compress') {
                        event.currentTarget.className = 'fa fa-expand';
                    } else {
                        event.currentTarget.className = 'fa fa-compress';
                    }
                };

                $scope.formOptions = { formState: $scope.formState };

                $scope.add = function() {
                    if (!$scope.model[$scope.options.key]) $scope.model[$scope.options.key] = [];
                    $scope.model[$scope.options.key].push({});
                };

                $scope.remove = function(index) {
                    $scope.model[$scope.options.key].splice(index, 1);
                    $scope.form.$setDirty();
                };

                $scope.copyFields = function copyFields(fields) {
                    fields = angular.copy(fields);
                    addRandomIds(fields);
                    return fields;
                };

                $scope.up = function(index) {
                    const array = $scope.model[$scope.options.key];
                    // if prev exist
                    if (array[index - 1]) {
                        // Swap elements
                        array.splice(index - 1, 2, array[index], array[index - 1]);
                        $scope.form.$setDirty();
                    }
                };

                $scope.down = function(index) {
                    const array = $scope.model[$scope.options.key];
                    // if next exist
                    if (array[index + 1]) {
                        // Swap elements
                        array.splice(index, 2, array[index + 1], array[index]);
                        $scope.form.$setDirty();
                    }
                };

                function addRandomIds(fields) {
                    unique++;
                    angular.forEach(fields, function(field, index) {
                        if (field.fieldGroup) {
                            addRandomIds(field.fieldGroup);
                            return; // fieldGroups don't need an ID
                        }

                        if (field.templateOptions && field.templateOptions.fields) {
                            addRandomIds(field.templateOptions.fields);
                        }
                        field.id = field.id || (field.key + '_' + index + '_' + unique + getRandomInt(0, 9999));
                    });
                }

                function getRandomInt(min, max) {
                    return Math.floor(Math.random() * (max - min)) + min;
                }

            }],

        });

    }]);
})(angular.module('rocket.components'));
